<template>
    <div class="">
        <div v-if="anexo.url_thumbnail && mostrarComoThumbnail" class="relative" style="width: 86px; height: 86px">
            <img :src="anexo.url_thumbnail" class="rounded cursor-pointer" style="width: 86px; height: 86px" />

            <div
                class="
                    absolute
                    cursor-pointer
                    top-0
                    left-0
                    w-full
                    h-full
                    flex
                    items-center
                    justify-center
                    space-x-1
                    hover:bg-black-20%
                "
                @click.self="abrirAnexo($event)"
                @mouseenter="hover = true"
                @mouseleave="hover = false"
            >
                <a
                    v-show="hover"
                    :href="anexo.url"
                    target="_blank"
                    reflinks="false"
                    class="p-2 rounded bg-black-20% hover:bg-black-50%"
                >
                    <alo-icon icon="outline-download" class="w-4 h-4 text-white" />
                </a>

                <button
                    v-show="hover && mostrarRemover"
                    class="p-2 rounded bg-black-20% hover:bg-black-50%"
                    @click="$emit('remover', anexo)"
                >
                    <alo-icon icon="outline-x" class="w-4 h-4 text-white" />
                </button>
            </div>
        </div>

        <div v-else-if="mostrarAudioPlayer">
            <AudioPlayer :src="anexo.url" :anexo="anexo" :event-id="eventId" :transcription="transcription" />
        </div>

        <div v-else-if="mostrarVideoPlayer">
            <VideoPlayer :src="anexo.url" :anexo="anexo" :event-id="eventId" />
        </div>

        <div
            v-else
            class="p-1 shadow rounded-md dark:bg-dark-800 dark:hover:bg-primary-700 bg-white text-gray-900"
            style="max-width: 180px"
        >
            <div v-if="anexo.progressoUpload" class="text-sm dark:text-white">
                <div>{{ anexo.nome_original }}</div>

                <div class="w-full h-2 bg-gray-400 rounded">
                    <div class="h-2 bg-primary-600" :style="'width:' + anexo.progressoUpload + '%'"></div>
                </div>

                <button v-show="mostrarRemover" class="px-1" @click="$emit('remover', anexo)">
                    <alo-icon icon="outline-x" class="w-4 h-4" />
                </button>
            </div>

            <div v-else class="flex items-center">
                <alo-icon icon="solid-document-download" class="w-6 h-6 flex-shrink-0 text-gray-600 dark:text-white" />

                <a :href="anexo.url" reflinks="false" target="_blank" class="truncate px-2 dark:text-white">
                    {{ anexo.nome_original }}
                </a>

                <button v-show="mostrarRemover" class="px-1" @click="$emit('remover', anexo)">
                    <alo-icon icon="outline-x" class="w-4 h-4" />
                </button>

                <a
                    v-show="mostrarDownload"
                    :href="'/core/arquivos/' + anexo.id"
                    reflinks="false"
                    target="blank"
                    class="h-full flex items-center justify-center px-1 hover:bg-gray-200"
                >
                    <alo-icon icon="outline-download" class="w-4 h-4" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import AudioPlayer from './AudioPlayer'
import VideoPlayer from './VideoPlayer'

export default {
    components: { AudioPlayer, VideoPlayer },
    props: [
        'anexo',
        'transcription',
        'mostrarComoThumbnail',
        'mostrarRemover',
        'mostrarDownload',
        'mostrarAudioPlayer',
        'mostrarVideoPlayer',
        'eventId',
    ],
    data() {
        return {
            hover: false,
        }
    },
    methods: {
        /**
         * Abre o anexo para o usuário visualizar o contato dentro da própria aplicação.
         * TODO: Hoje está abrindo em nova aba, fazer abrir em modal no futuro.
         *
         * @return {void}
         */
        abrirAnexo() {
            window.open(this.anexo.url, '_blank')
        },
    },
}
</script>
